import styled from 'styled-components';
import { fontBody, fontTitle } from 'Styles/fonts';

export const Prefix = styled.span`
  ${fontTitle(16)};
`;

export const Legend = styled.legend`
  ${fontBody(16)};
  text-transform: capitalize;
  padding-bottom: 6px;
  color: var(--foreground);
  white-space: nowrap;
  display: block;
`;
